import AbstractDashboardWidget from './abstractDashboardWidget';
import { ConstructorInput } from './dashboardWidgetFactory';

const ns = 'app.services.textBlockDashboardWidget';

export type Configurations = { content: string };

export default class TextBlockDashboardWidget extends AbstractDashboardWidget {
  #configurationsString: string;
  #configurations: Configurations | undefined;

  constructor(input: ConstructorInput) {
    super(input);
    this.#configurationsString = input.configurations;
  }

  getConfigurations(): Configurations {
    if (!this.#configurations) {
      const temp = JSON.parse(this.#configurationsString);
      if (typeof temp.content !== 'string') {
        throw new Error(`${ns}.getConfigurations: content is required in configurations`);
      }
      this.#configurations = temp as Configurations;
    }
    return this.#configurations;
  }
}
